export default "__VITE_ASSET__DCAFQXNA__"